var _circle, _ellipse, _ellipse2, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 216,
    viewBox: "0 0 185 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    fill: "url(#paint0_linear_11_1157)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_1157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 72,
    width: 103,
    height: 144
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.4999,
    cy: 98.5663,
    rx: 27.5893,
    ry: 26.5663,
    fill: "#333333"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.5,
    cy: 171.723,
    rx: 51.5,
    ry: 44.2771,
    fill: "#333333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_1157)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.0401,
    cy: 102.208,
    rx: 85.067,
    ry: 81.9127,
    fill: "#E9E4D4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.787 52.3305L93.0361 45.0825L92.8051 45L92.5741 45.0825L72.8207 52.3305L52.6102 59.7465L56.8525 61.3033L61.7495 63.1006C60.6877 65.1275 59.7026 68.9528 61.0338 75.664C60.0143 76.0723 59.2936 77.0637 59.2936 78.2259C59.2936 79.0573 59.6623 79.8004 60.2453 80.3079C59.6407 87.5579 54.7249 88.568 53.1175 88.7024C52.6122 88.7447 52.156 89.0804 52.0331 89.5721C51.514 91.6708 57.2261 93.793 60.6169 94.8541C62.1143 95.3233 63.7423 94.6303 64.4168 93.2158C67.0506 87.7002 65.2348 82.4281 64.1218 80.0703C64.5613 79.5815 64.8307 78.9366 64.8307 78.2269C64.8307 77.0028 64.0324 75.9683 62.9273 75.6051C62.597 72.94 62.1388 67.0407 64.0589 63.9487L69.4947 65.9432C70.4031 62.8316 75.7741 61.7224 77.6479 61.3376C81.7614 60.4905 87.267 60.0233 93.1531 60.0233C99.0097 60.0233 104.486 60.4866 108.57 61.3288C110.397 61.7047 115.586 62.7757 116.623 65.7558L128.757 61.3042L133 59.7474L112.787 52.3305Z",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66.1411L71 79.5C76 74 83.8711 70.5 92 70.5C100.129 70.5 105.5 72.5 115 79.5V66.1135C114.997 59.2771 70.997 59.3048 71 66.1411Z",
    fill: "#363636"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_1157",
    x1: 93,
    y1: -40,
    x2: 92.5,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426985,
    stopColor: "#25374D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768372,
    stopColor: "#547BAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/Student Icon.fda76b6cb4438444a0a9c189a66af2e2.svg";
export { ForwardRef as ReactComponent };